@if(tenant()) {
@let t = tenant()!;
<nav class="d-flex justify-content-start align-items-center bg rounded">
  <div><mat-icon>perm_identity</mat-icon></div>
  <a class="flex-grow-1 no-underline ms-3 me-3" [routerLink]="['', t._id, 'home']"><span class="">{{t?.profile?.companyName ?? t?._id}}</span></a>
  <a [routerLink]="['',t._id,'planning']" class="no-underline me-3">Azioni</a>
  <a [routerLink]="['',t._id,'reports']" class="no-underline me-3">Relazioni</a>
  <a [routerLink]="['',t._id,'account', 'purposes']" class="no-underline">Profilo</a>

  <button class="ms-auto" mat-icon-button (click)="cancel()"><mat-icon>cancel</mat-icon></button>
</nav>
}

